import React from "react";
import { useParams } from "react-router-dom";
import AppSettings from "../../config";

export default () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const legacyUrl = `${AppSettings.GOGOV_WEB_URL}/${site}/editcase.php?cmd=edit&pagewhendone=${window.location.origin}/${site}/crm&id=${id}`;
  window.location.href = legacyUrl;
  return <div>Redirecting...</div>;
};
